<template>
  <v-container class="py-0">
    <v-row>
      <v-col>
        <div class="display-1 font-weight-normal mb-6 text-center">
          Vamos preencher as informações necessárias para a etapa do Banco de Compras
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <validation-provider
          v-slot="{ errors, valid }"
          rules="required"
        >
          <validation-helper
            :interceptor="valid"
            @isValid="
              $emit('step-observer-fluxo-pagamento', {
                step: 'fluxo-pagamento',
                complete: $event,
              })
            "
          />
          <v-select
            v-model="fluxoPagamentoSelecionado"
            outlined
            :error-messages="errors"
            :items="itemsFluxoPagamento"
            item-value="id"
            item-text="name"
            placeholder="Selecione o fluxo de pagamento"
            label="Fluxo de Pagamento"
          />
        </validation-provider>
      </v-col>
      <v-col>
        <validation-provider
          v-slot="{ errors, valid }"
          rules="required"
        >
          <validation-helper
            :interceptor="valid"
            @isValid="
              $emit('step-observer-valor-odc', { step: 'valor-odc', complete: $event })
            "
          />
          <!-- <v-text-field
            v-model="valorOdc"
            outlined
            :error-messages="errors"
            label="Valor de ODC"
            placeholder="Insira o valor de ODC"
          /> -->
          <vuetify-money
            v-model="valorOdc"
            label="Valor de ODC"
            :error-messages="errors"
            placeholder="Insira o valor de ODC"
            outlined
            v-bind:valueWhenIsEmpty="valueWhenIsEmpty"
            :options="options"
          />
        </validation-provider>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        class="pb-0"
      >
        <v-checkbox v-model="flagLegislacao">
          <template v-slot:label>
            <div style="color: #6e6e6e">
              Legislação permite crédito de ICMS no ativo
            </div>
          </template>
        </v-checkbox>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  components: {
    DatePicker:       () => import('@/components/general/DatePicker.vue'),
    ValidationHelper: () => import('@/components/general/ValidationHelper.vue')
  },

  data: () => ({
    itemsFluxoPagamento: [
      {
        name: 'do Arquivo SDI',
        id: 1
      },
      {
        name: 'Projetar',
        id: 0
      }
    ],
    money: {
      currency: "BRL",
      currencyDisplay: "symbol",
      hideCurrencySymbolOnFocus: false,
      hideGroupingSeparatorOnFocus: false,
      hideNegligibleDecimalDigitsOnFocus: false,
      autoDecimalDigits: false,
      useGrouping: true,
      accountingSign: false
    },
    fluxoPagamentoSelecionado: null,
    valorOdc: null,
    value: "1234567.89",
    label: "Value",
    placeholder: " ",
    readonly: false,
    disabled: false,
    outlined: true,
    clearable: true,
    valueWhenIsEmpty: "",
    options: {
      locale: "pt-BR",
      prefix: "R$",
      suffix: "",
      length: 11,
      precision: 2
    },
    flagLegislacao: true
  }),

  methods: {
    exportData() {
      return {
        fluxoPagamentoSelecionado: this.fluxoPagamentoSelecionado,
        valorOdc: parseFloat(this.valorOdc.replace(/[^\d,]/g, '').replace(',', '.')),
        flagLegislacao: this.flagLegislacao == false ? 0 : 1
      };
    }
  }
};
</script>
